import { CSSProperties } from 'react'
import styled from 'styled-components'
import { useElementSize, useWindowSize } from 'usehooks-ts'
import means from '../MainComponent/mean_values.json'
import { cantons } from 'components/constants'
import { useMFContext } from 'components/MFHelpers'


export const GroupDisplayBar = ({
  userPosition,
  userAge,
  userCanton,
  hideLabel,
  iconColors = ['var(--text-color)', 'var(--text-color)'],
  style,
  isOn,
  income,
  wealth,
}: // returnGroupHeight,
{
  userPosition: number | undefined
  userAge: number
  userCanton: string
  hideLabel?: boolean
  iconColors?: string[]
  style?: CSSProperties
  isOn?: boolean
  income: number
  wealth: number
  // returnGroupHeight?: (height: number) => void
}) => {
  const { _t } = useMFContext()

  const locales = {
    title: _t('group_display_bar_title'),
    middleIncome: _t('group_display_bar_middle_income'),
    middleSavings: _t('group_display_bar_middle_savings'),
    xAxisTitle: _t('group_display_bar_x_axis_title'),
  }

  const groups = [
    {
      count: 10,
      label: _t('group_1'),
    },
    {
      count: 15,
      label: _t('group_2'),
    },
    {
      count: 25,
      label: _t('group_3'),
    },
    {
      count: 25,
      label: _t('group_4'),
    },
    {
      count: 15,
      label: _t('group_5'),
    },
    {
      count: 10,
      label: _t('group_6'),
    },
  ]
  const [ref, { width=0 }] = useElementSize()
  const windowSize = useWindowSize()
  const ismob = windowSize.width < 712

  return (
    <GroupDisplayRoot ref={ref} style={style}>
      <TitleWrapper>
        <Title>{locales.title}</Title>

        <IconKey>
          <KeyEntry>
            <img
              alt='Icon Einkommen'
              src={require('../../images/icons_income_grey.png')}
              className='savings'
            />
            {locales.middleIncome}
          </KeyEntry>
          <KeyEntry>
            <img
              alt='Icon Vermögen'
              src={require('../../images/icons_saving_grey.png')}
              className='savings'
            />
            {locales.middleSavings}
          </KeyEntry>
        </IconKey>
      </TitleWrapper>
      <Column>
        {groups.map(({ count, label }, index) => {
          const widthpercent = (width / (ismob ? 65 : 100)) * (count * 2.5)
          var groupmeans
          if (index === userPosition) {
            groupmeans = means.filter((f: any) => {
              var age = f.age_group.split('-')
              var agemin = parseInt(age[0])
              var agemax = parseInt(age[1])
              var canton_abr = cantons.find(
                (a) => a.labelLong === userCanton
              )?.label
              if (
                userAge >= agemin &&
                userAge <= agemax &&
                f.kanton === canton_abr &&
                5 - userPosition === f.wealth_group
              )
                return true
              return false
            })[0]
          }
          return (
            <>
              <Bar
                style={{
                  minWidth: '100%',
                  minHeight: ismob ? 60 + 'px' : 75 + 'px',
                }}
                key={index}
              >
                <Shape
                  style={{
                    width: widthpercent,
                    backgroundColor:
                      index === userPosition
                        ? 'var(--yellow-main)'
                        : 'var(--chart-bar-color)',
                    color:
                      index === userPosition
                        ? 'var(--brandblue-main)'
                        : undefined,
                    border: '1px solid var(--site-background)',
                  }}
                />
                <Label
                  style={{
                    color:
                      index === userPosition
                        ? 'var(--brandblue-main)'
                        : undefined,
                  }}
                >
                  {count}%<span>{label}</span>
                </Label>
                {index === userPosition && (
                  <Marker
                    className='Marker'
                    style={{
                      left: Math.min(200, widthpercent - 10) + 'px',
                    }}
                  >
               
                    {groupmeans && (
                      <Group>
                        <Row>
                          <img
                            alt='Icon Einkommen'
                            src={require('../../images/icons_income.png')}
                            className='income'
                          />
                          {formatNumber(income || 0)} Fr.
                        </Row>
                        <Row>
                          <img
                            alt='Icon Vermögen'
                            src={require('../../images/icons_saving.png')}
                            className='savings'
                          />
                          {formatNumber(wealth || 0)} Fr.
                        </Row>
                      </Group>
                    )}
                  </Marker>
                )}
              </Bar>
            </>
          )
        })}
      </Column>
      <XAxisLabel>{locales.xAxisTitle}</XAxisLabel>
    </GroupDisplayRoot>
  )
}
function formatNumber(n: number) {
  if (n < 10000) return n
  return n.toLocaleString('ch-DE').replace('.', "'")
}
const XAxisLabel = styled.div`
  width: 100%;
  max-width: 330px;
  font-size: 14px;
  letter-spacing: 0.2px;
`

const IconKey = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 15px;
  color: var(--gray-3);
  font-size: 14px;
  line-height: 1.2em;
`
const KeyEntry = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  img {
    margin-right: 5px;
  }
`
const TitleWrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  line-height: 1.6em;
  margin-bottom: 30px;
`

const Title = styled.div`
  flex: 0 0 100%;
  font-size: 26px;
  line-height: 1.4em;
  font-weight: 200;
  letter-spacing: 0.6px;
  text-align: center;
  margin-bottom: 5px;
  @media screen and (max-width: 712px) {
    font-size: 18px;
  }
`

const Marker = styled.div`
  /* flex: 0 0 100%; */
  background-color: #fff;
  width: 120px;
  height: 50px;
  position: absolute;
  /* right: 10px; */
  top: 50%;
  transform: translateY(-50%);
  color: var(--brandblue-main);
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  img.average {
    max-width: 16px;
  }
  /* -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.29);
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.29); */

  filter: drop-shadow(0px 0px 4px rgba(32, 35, 70, 0.2));
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #fff;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
  }
`
const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  img {
    margin-right: 4px;
  }
`

const Group = styled.div`
  line-height: 1em;
  padding-left: 4px;
`

const Column = styled.div`
  max-width: 400px;
  padding-bottom: 2px;
  /* height: 400px; */
  box-sizing: border-box;
  display: flex;
  gap: 0;
  flex-direction: column;
  width: 100%;
  font-size: 15px;
  border-bottom: 2px solid var(--text-color);
  position: relative;
  &::after {
    position: absolute;
    top: 100%;
    right: -10px;
    transform: translateY(-50%);
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;

    border-left: 16px solid var(--text-color);
  }
  @media screen and (max-width: 712px) {
    /* height: 500px; */
  }
`

const Bar = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* background-color: var(--text-color); */
  color: var(--site-background);
  justify-content: flex-start;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
  position: relative;
  margin-bottom: 1px;

  &::before {
    content: '';
    position: absolute;
    left: -6px;
    top: -1px;
    height: calc(100% + 2px);
    width: 1px;
    border-left: 2px solid var(--text-color);
  }
`
const Label = styled.div`
  font-family: var(--font-sans-serif);
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  line-height: 1.5em;
  font-size: 14px;

  span {
    display: inline-block;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.6px;
  }
  @media screen and (max-width: 712px) {
    font-size: 13px;

    span {
      font-size: 15px;
    }
  }
`
const Shape = styled.div`
  height: 100%;
  /* padding-left: 30px;
  padding-right: 30px; */
  display: flex;
  align-items: center;
`

const GroupDisplayRoot = styled.div.attrs({ className: 'GroupDisplay' })`
  max-width: 100vw;
  position: relative;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`
